import { render, staticRenderFns } from "./UpdateArrestModal.vue?vue&type=template&id=34483b6f&scoped=true&"
import script from "./UpdateArrestModal.vue?vue&type=script&lang=ts&"
export * from "./UpdateArrestModal.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateArrestModal.vue?vue&type=style&index=0&id=34483b6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34483b6f",
  null
  
)

/* custom blocks */
import block0 from "./UpdateArrestModal.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports